import * as core from '../../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'sr:awards',
    content: {
      root: {
        elements: [
          {
            height: 800,
            content: {
              widget: {
                widget: {
                  alias: 'sr.awards.widgets.awards-table',
                },
              },
            },
          },
        ],
      },
    },
    description: 'Awards',
    name: 'Awards',
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
